module.exports = __webpack_public_path__ + "static/smart_2-a01c6201dc775dd44e8c4a914ea57088.png";